import React from 'react'
import { Route, Routes } from 'react-router-dom'
import NotFoundPage from '../pages/error/404'
import Products from '../pages/admin/products/Products'
import Menu from '../components/menus/Menu'
import ProductHistory from '../pages/admin/ProductHistory'
import Departments from '../pages/admin/Departments'
import ProductTemplates from '../pages/admin/ProductTemplates'
import Chatbot from '../pages/Chatbot'
import Dashboard from '../pages/user/Dashboard'
import Sidebar from '../components/menus/Sidebar'
import BottomNav from '../components/menus/BottomNav'
import CabeceraMovil from '../components/menus/CabeceraMovil'
import { useAuth } from '../components/auth/useAuth'

export default function DepartmentRouter() {
	const {clientauth} = useAuth()

	return (
		<div className="app-layout">
			<Sidebar/>
			<CabeceraMovil rol={clientauth?.rol ?? ""}/>
			<div className="app-content">
				<Menu />
				<div className="app-main">
				<Routes>
					<Route path="/dashboard" element={<Dashboard />} />
					<Route path="/products" element={<Products />} />
						<Route path="/product-history/:id" element={<ProductHistory />} />
						<Route path="/departments" element={<Departments />} />
						<Route path="/product-templates" element={<ProductTemplates />} />
						<Route path="/chatbot" element={<Chatbot />} />
						<Route path="*" element={<NotFoundPage />} />
					</Routes>
				</div>
			</div>
			<BottomNav/>
		</div>
	)
}
